import Homepage from './pages/home';
import './styles/App.css';

function App() {
  return (
    <>
      <Homepage />
    </>
  );
}

export default App;
